

import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import { getSucursalUuid } from '@/store/modules/sucursales/contexto'

export default {
    namespaced: true,
    state: {
        loadData: false,
        dataInit: {
            hasSucursal: false,
            hasCaja: false,
            hasArqueo: false
        }, loadingDataInit: false, error: false, errorMessage: 'errorMessage'
    },
    mutations: {
        //Esta variable indica si se realizó la petición de la info necesaria del sistema.
        setLoadData(state, bool) {
            state.loadData = bool
        },
        SET_LOADING_DATA_INIT(state, bool) {
            console.log("SET_LOADING_DATA_INIT, el parametro que llega es: ", bool);
            state.loadingDataInit = bool
        },
        SET_DATA_INIT(state, data) {
            console.log("SET_DATA_INIT, el parametro que llega es: ", data);

            state.dataInit = data
        },
        SET_ERROR(state, payload) {
            state.error = payload.error;
            state.errorMessage = payload.errorMessage;
        }
    },
    getters: {

    },
    actions: {




        async fetchConfiguracion(context) {
            await context.dispatch('sucursales/fetch_configuracion', {}, { root: true })

        },



        async fetchSucursalInfo(context) {
            await context.dispatch('sucursales/fetch_sucursal_info', {}, { root: true })
        },



        async fetchInitConfig(context) {
            context.commit('SET_LOADING_DATA_INIT', true);
            try {
                const result = {
                    hasSucursal: false,
                    hasCaja: false,
                    hasArqueo: false
                };

                // 1. Validar contexto de sucursal
                if (!getSucursalUuid()) {
                    context.commit('setLoadData', true);
                    context.commit('SET_LOADING_DATA_INIT', false);
                    context.commit('SET_DATA_INIT', result);

                    return result; // No sucursal
                }
                result.hasSucursal = true;

                // 2. Validar sucursal
                const sucursal = await context.dispatch('sucursales/validate_asignacion_sucursal', null, { root: true });
                if (!sucursal.success) {
                    context.commit('setLoadData', true);
                    context.commit('SET_LOADING_DATA_INIT', false);
                    context.commit('SET_DATA_INIT', result);


                    return result; // No sucursal válida
                }

                // 3. Cargar configuración
                const configuracion = await context.dispatch('sucursales/fetch_configuracion', null, { root: true });
                if (!configuracion.success) {
                    context.commit('setLoadData', true);
                    context.commit('SET_LOADING_DATA_INIT', false);
                    context.commit('SET_DATA_INIT', result);

                    return result; // No configuración
                }

                // 4. Validar caja
                const cajaResp = await context.dispatch('sucursales/validate_caja', {}, { root: true });

                if (!cajaResp.success || !cajaResp.response.data.caja) {
                    context.commit('setLoadData', true);
                    context.commit('SET_LOADING_DATA_INIT', false);
                    context.commit('SET_DATA_INIT', result);
                    return result;
                }

                result.hasCaja = true;

                // 5. Obtener arqueo vigente
                const arqueo = await context.dispatch('sucursales/fetchArqueoVigente', {}, { root: true });
                if (!arqueo.success) {
                    context.commit('setLoadData', true);
                    context.commit('SET_LOADING_DATA_INIT', false);
                    context.commit('SET_DATA_INIT', result);

                    return result; // No arqueo
                }
                context.commit('setLoadData', true);
                context.commit('SET_LOADING_DATA_INIT', true);

                result.hasArqueo = true;
                context.commit('SET_DATA_INIT', result);


                return result;

            } catch (error) {
                console.error('Error en fetchInitConfig:', error);
                return { hasSucursal: false, hasCaja: false, hasArqueo: false };
            } finally {
                context.commit('SET_LOADING_DATA_INIT', false);
            }
        },

        async waitForLoad(context) {
            // Puedes definir una condición que debe cumplirse antes de continuar
            // Por ejemplo, esperar a que loadData sea true
            while (!context.state.initialData.loadData) {
                // Espera un tiempo (puedes ajustar este valor según tus necesidades)
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        },
        async updateSystem(context) {
            // Actualiza los nuevos registros en el backend  la utlima version    
            var url = "/productos/actualizardatos";
            try {
                context.commit('setLoadingSystemUpdate', true, { root: true })
                const response = await Vue.axios({
                    method: 'GET',
                    url: url
                })
                context.commit('setSystemUpdate', true, { root: true })
                context.commit('setLoadingSystemUpdate', false, { root: true })
            }
            catch (error) {
                context.commit('setErrorSystemUpdate', true, { root: true })
                context.commit('setLoadingSystemUpdate', false, { root: true })
            }
        },
    }
}